export default [
  // Hogwarts
  {
    id: '20000',
    firstName: 'Severus',
    lastName: 'Snape',
    name: 'Severus Snape',
    email: 'ssnape@hogwarts.test',
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Hogwarts School of Witchcraft and Wizardry',
    linkedPurchaserId: '10011',
  },
  {
    id: '20001',
    firstName: 'Minerva',
    lastName: 'McGonagall',
    name: 'Minerva McGonagall',
    email: 'mmcgonagall@hogwarts.test',
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Hogwarts School of Witchcraft and Wizardry',
    linkedPurchaserId: '10011',
  },
  {
    id: '20002',
    firstName: 'Aurora',
    lastName: 'Sinistra',
    name: 'Aurora Sinistra',
    email: 'asinistra@hogwarts.test',
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Hogwarts School of Witchcraft and Wizardry',
    linkedPurchaserId: '10011',
  },
  {
    id: '20003',
    firstName: 'Bathsheda',
    lastName: 'Babbling',
    name: 'Bathsheda Babbling',
    email: 'bbabbling@hogwarts.test',
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Hogwarts School of Witchcraft and Wizardry',
    linkedPurchaserId: '10011',
  },
  {
    id: '20004',
    firstName: 'Charity',
    lastName: 'Burbage',
    name: 'Charity Burbage',
    email: 'cburbage@hogwarts.test',
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Hogwarts School of Witchcraft and Wizardry',
    linkedPurchaserId: '10011',
  },
  {
    id: '20005',
    firstName: 'Filius',
    lastName: 'Flitwick',
    name: 'Filius Flitwick',
    email: 'fflitwick@hogwarts.test',
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Hogwarts School of Witchcraft and Wizardry',
    linkedPurchaserId: '10011',
  },
  {
    id: '20006',
    firstName: 'Pomona',
    lastName: 'Sprout',
    name: 'Pomona Sprout',
    email: 'psprout@hogwarts.test',
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Hogwarts School of Witchcraft and Wizardry',
    linkedPurchaserId: '10011',
  },
  {
    id: '20007',
    firstName: 'Remus',
    lastName: 'Lupin',
    name: 'Remus Lupin',
    email: 'rlupin@hogwarts.test',
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Hogwarts School of Witchcraft and Wizardry',
    linkedPurchaserId: '10011',
  },

  // Community
  // https://en.wikipedia.org/wiki/List_of_Community_characters
  {
    id: '200901',
    firstName: 'Michelle',
    lastName: 'Slater',
    name: 'Michelle Slater',
    email: 'm.slater@greendale.edu.test',
    preferredDisplayName: 'Ms. Slater',
    avatarSmallUrl: '/assets/test-fixtures/Professor_Slater.webp',
    avatarMediumUrl: '/assets/test-fixtures/Professor_Slater.webp',
    // Wed Jul 31 2024 17:00:00 GMT-0700 (Pacific Daylight Time)
    // Thu, 01 Aug 2024 00:00:00 GMT
    lastUserAccess: 1722470400000,
    emailStatus: 'VERIFIED',
    accountStatus: 'SYNCED',
    pro: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200902',
    firstName: 'Eustice',
    lastName: 'Whitman',
    name: 'Eustice Whitman',
    email: 'e.whitman@greendale.edu.test',
    preferredDisplayName: 'Mr. Whitman',
    // 2022-12-02T12:41:03+00:00,
    lastUserAccess: 1669984863000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200903',
    firstName: 'Sean',
    lastName: 'Garrity',
    name: 'Sean Garrity',
    email: 's.garrity@greendale.edu.test',
    preferredDisplayName: 'Mr. Garrity',
    avatarSmallUrl: '/assets/test-fixtures/Professor_Garrity.webp',
    avatarMediumUrl: '/assets/test-fixtures/Professor_Garrity.webp',
    // 2022-12-03T15:21:03+00:00,
    lastUserAccess: 1670080863000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    soloPro: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200904',
    firstName: 'June',
    lastName: 'Bauer',
    name: 'June Bauer',
    email: 'j.bauer@greendale.edu.test',
    preferredDisplayName: 'Mrs. Bauer',
    avatarSmallUrl: '/assets/test-fixtures/June.webp',
    avatarMediumUrl: '/assets/test-fixtures/June.webp',
    // 2022-12-05T09:14:03+00:00,
    lastUserAccess: 1670231643000,
    emailStatus: 'VERIFIED',
    accountStatus: 'SYNCED',
    pro: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
    linkedDistrictId: '10000',
    linkedDistrictName: 'Colorado Fictional District',
  },
  {
    id: '200905',
    firstName: 'Marshall',
    lastName: 'Kane',
    name: 'Marshall Kane',
    email: 'm.kane@greendale.edu.test',
    preferredDisplayName: 'Mr. Kane',
    // 2022-12-06T17:49:03+00:00,
    lastUserAccess: 1670348943000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200906',
    firstName: 'Noel',
    lastName: 'Cornwallis',
    name: 'Noel Cornwallis',
    email: 'n.cornwalliskane@greendale.edu.test',
    preferredDisplayName: 'Mr. Cornwallis',
    // 2022-12-06T13:36:03+00:00,
    lastUserAccess: 1670333763000,
    emailStatus: 'VERIFIED',
    accountStatus: 'PENDING',
    pro: true,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200907',
    firstName: 'Cory',
    lastName: 'Radison',
    name: 'Cory Radison',
    email: 'c.radison@greendale.edu.test',
    preferredDisplayName: 'Mr. Radison',
    // 2022-12-07T18:24:03+00:00,
    lastUserAccess: 1670437443000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: '',
    linkedPurchaserId: '',
    linkedDistrictId: '10000',
    purchaserLinkType: 'NO_SCHOOL',
  },
  {
    id: '200908',
    firstName: 'Lee',
    lastName: 'Slaughter',
    name: 'Lee Slaughter',
    email: 'l.slaughter@greendale.edu.test',
    preferredDisplayName: 'Mr. Slaughter',
    avatarSmallUrl: '/assets/test-fixtures/Slaughter.webp',
    avatarMediumUrl: '/assets/test-fixtures/Slaughter.webp',
    // 2022-12-08T10:13:03+00:00,
    lastUserAccess: 1670494383000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200909',
    firstName: 'Marion',
    lastName: 'Holly',
    name: 'Marion Holly',
    email: 'm.holly@greendale.edu.test',
    preferredDisplayName: 'Mr. Holly',
    // 2022-12-08T14:28:03+00:00,
    lastUserAccess: 1670509683000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'PENDING',
    pro: false,
    linkedPurchaserName: 'Greendale Secondary School',
    linkedPurchaserId: '10002',
    linkedDistrictId: '10000',
  },
  {
    id: '200910',
    firstName: 'Peter',
    lastName: 'Sheffield',
    name: 'Peter Sheffield',
    email: 'p.sheffield@greendale.edu.test',
    preferredDisplayName: 'Mr. Sheffield',
    // 2022-12-09T12:24:03+00:00,
    lastUserAccess: 1670588643000,
    emailStatus: 'VERIFIED',
    accountStatus: 'SYNCED',
    pro: false,
    linkedPurchaserName: '',
    linkedPurchaserId: '',
    linkedDistrictId: '',
    purchaserLinkType: 'EXTERNAL',
  },
  {
    id: '200911',
    firstName: 'Stephen',
    lastName: 'Spreck',
    name: 'Stephen Spreck',
    email: 's.spreck@city-college.edu.test',
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200912',
    firstName: 'Jeremy',
    lastName: 'Simmons',
    name: 'Jeremy Simmons',
    email: 'j.simmons@city-college.edu.test',
    emailStatus: 'VERIFIED',
    accountStatus: 'PENDING',
    pro: false,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200913',
    firstName: 'Inspector',
    lastName: 'Spacetime',
    name: 'Inspector Spacetime',
    email: 'i.spacetime@greendale.edu.test',
    preferredDisplayName: 'The Inspector',
    // 2022-12-09T12:24:03+00:00,
    lastUserAccess: 1670588643000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'DEACTIVATED',
    pro: false,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200914',
    firstName: 'Pillow',
    lastName: 'Man',
    name: 'Pillow Man',
    email: 'pillow.man@greendale.edu.test',
    preferredDisplayName: 'Pillow Man',
    // 2022-12-09T12:24:03+00:00,
    lastUserAccess: 1670588643000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'DEACTIVATED',
    pro: false,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },
  {
    id: '200915',
    firstName: 'Kickpuncher',
    lastName: '',
    name: 'Kickpuncher',
    email: 'kickpuncher@greendale.edu.test',
    preferredDisplayName: 'kickpuncher',
    // 2022-12-09T12:24:03+00:00,
    lastUserAccess: 1670588643000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'DEACTIVATED',
    pro: false,
    linkedPurchaserName: 'Greendale Community College',
    linkedPurchaserId: '10002',
  },

  // Clone High
  // https://en.wikipedia.org/wiki/List_of_Clone_High_characters
  {
    id: '30000',
    firstName: 'Cinnamon',
    lastName: 'Scudworth',
    name: 'Cinnamon J. Scudworth',
    email: 'c.scudworth@clone.high.edu.test',
    preferredDisplayName: 'Principal Scudworth',
    // 2021-01-22T12:24:03+00:00,
    lastUserAccess: 1611318243000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Clone High',
    linkedPurchaserId: '11000',
  },
  {
    id: '30001',
    firstName: 'Lynn',
    lastName: 'Butlertron',
    name: 'Lynn Butlertron',
    email: 'l.butlertron@clone.high.edu.test',
    preferredDisplayName: 'Mr. B',
    // 2021-01-22T12:24:03+00:00,
    lastUserAccess: 1611318243000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Clone High',
    linkedPurchaserId: '11000',
  },
  {
    id: '30002',
    firstName: 'Mr.',
    lastName: 'Sheepman',
    name: 'Mr. Sheepman',
    email: 'mr.sheepman@clone.high.edu.test',
    preferredDisplayName: 'Mr. Sheepman',
    // 2021-01-22T12:24:03+00:00,
    lastUserAccess: 1611318243000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Clone High',
    linkedPurchaserId: '11000',
  },
  {
    id: '30003',
    firstName: 'Eleanor',
    lastName: 'Roosevelt',
    name: 'Eleanor Roosevelt',
    email: 'eleanor.roosevelt@clone.high.edu.test',
    preferredDisplayName: 'Eleanor Roosevelt',
    // 2021-01-22T12:24:03+00:00,
    lastUserAccess: 1611318243000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Clone High',
    linkedPurchaserId: '11000',
  },
  {
    id: '30004',
    firstName: 'Glenn',
    lastName: 'Matthews',
    name: 'Glenn Matthews',
    email: 'g.matthews@clone.high.edu.test',
    preferredDisplayName: 'Glenn the Janitor',
    // 2021-01-22T12:24:03+00:00,
    lastUserAccess: 1611318243000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: 'Clone High',
    linkedPurchaserId: '11000',
  },
  // Test District: Rocky Mountain School Trust
  // Athabasca High School
  {
    id: '40100',
    firstName: 'Mark',
    lastName: 'Ellington',
    name: 'Mark Ellington',
    email: 'mellington@athabascahs.edu',
    preferredDisplayName: 'Mr. Ellington',
    // 2023-04-12T23:45:00.000Z,
    lastUserAccess: 1681343100000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
  },
  {
    id: '40101',
    firstName: 'Helen',
    lastName: 'Melnyk',
    name: 'Helen Melnyk',
    email: 'hmelnyk@athabascahs.edu',
    preferredDisplayName: 'Miss Helen',
    // 2023-04-17T06:00:00.000Z,
    lastUserAccess: 1681711200000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
  },
  {
    id: '40102',
    firstName: 'Anna',
    lastName: 'Rodriguez',
    name: 'Anna Rodriguez',
    email: 'arodriguez@athabasca.rmst.edu',
    preferredDisplayName: 'Mrs. Rodriguez',
    // 2023-04-19T06:00:00.000Z,
    lastUserAccess: 1681884000000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
  },
  {
    id: '40103',
    firstName: 'Imani',
    lastName: 'Carter',
    name: 'Imani Carter',
    email: 'icarter@athabasca.rmst.edu',
    preferredDisplayName: 'Ms Carter',
    // 2023-04-20T06:00:00.000Z,
    lastUserAccess: 1681970400000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
  },
  {
    id: '40104',
    firstName: 'Christopher',
    lastName: 'Patterson',
    name: 'Christopher Patterson',
    email: 'cpatterson@athabasca.rmst.edu',
    preferredDisplayName: 'Mr Chris',
    // 2023-04-21T06:00:00.000Z,
    lastUserAccess: 1682056800000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
  },
  {
    id: '40105',
    firstName: 'David',
    lastName: 'Chang',
    name: 'David Chang',
    email: 'dchang@athabasca.rmst.edu',
    preferredDisplayName: 'Mr. Chang',
    // 2023-04-18T06:00:00.000Z,
    lastUserAccess: 1681797600000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
  },
  {
    id: '40106',
    firstName: 'Nafisa',
    lastName: 'Chaudhary',
    name: 'Nafisa Chaudhary',
    email: 'nchaudhary@athabasca.rmst.edu',
    preferredDisplayName: 'Mrs. C',
    // 2023-04-21T06:00:00.000Z,
    lastUserAccess: 1682056800000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
  },
  {
    id: '40107',
    firstName: 'Kari',
    lastName: 'Johansen',
    name: 'Kari Johansen',
    email: 'kjohansen@rmst.edu',
    preferredDisplayName: 'Miss KJ',
    // 2023-04-20T06:00:00.000Z,
    lastUserAccess: 1681970400000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
  },
  {
    id: '40108',
    firstName: 'Susan',
    lastName: 'James',
    name: 'Susan James',
    email: 'sjames@athabasca.rmst.edu',
    preferredDisplayName: 'Ms. James',
    // 2023-04-21T06:00:00.000Z,
    lastUserAccess: 1682056800000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
  },
  {
    id: '40109',
    firstName: 'Hassan',
    lastName: 'Khouri',
    name: 'Hassan Khouri',
    email: 'hkhouri@athabasca.rmst.edu',
    preferredDisplayName: 'Mr. H',
    // 2023-04-19T06:00:00.000Z,
    lastUserAccess: 1681884000000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Athabasca High School',
    linkedPurchaserId: '12001',
  },
  // Brazeau Elementary School
  {
    id: '40200',
    firstName: 'Katharine',
    lastName: 'Tate',
    name: 'Katharine Tate',
    email: 'ktate@brazeau.rmst.edu',
    preferredDisplayName: 'Miss Katharine',
    // 2023-04-18T06:00:00.000Z,
    lastUserAccess: 1681797600000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
  {
    id: '40201',
    firstName: 'Peter',
    lastName: 'Lam',
    name: 'Peter Lam',
    email: 'plam@brazeau.rmst.edu',
    preferredDisplayName: 'Mr. Lam',
    // 2023-04-21T06:00:00.000Z,
    lastUserAccess: 1682056800000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
  {
    id: '40202',
    firstName: 'Heather',
    lastName: 'Luna',
    name: 'Heather Luna',
    email: 'hluna@brazeau.rmst.edu',
    preferredDisplayName: 'Ms. Luna',
    // 2023-04-19T06:00:00.000Z,
    lastUserAccess: 1681884000000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
  {
    id: '40203',
    firstName: 'Hannah',
    lastName: 'Khan',
    name: 'Hannah Khan',
    email: 'hkhan@brazeau.rmst.edu',
    preferredDisplayName: 'Mrs. Khan',
    // 2023-04-20T06:00:00.000Z,
    lastUserAccess: 1681970400000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
  {
    id: '40204',
    firstName: 'Tim',
    lastName: 'Hudson',
    name: 'Tim Hudson',
    email: 'thudson@brazeau.rmst.edu',
    preferredDisplayName: 'Mr. Hudson',
    // 2023-04-24T06:00:00.000Z,
    lastUserAccess: 1682316000000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
  {
    id: '40205',
    firstName: 'Rebecca',
    lastName: 'Lee',
    name: 'Rebecca Lee',
    email: 'rlee@rmst.edu',
    preferredDisplayName: 'Miss Lee',
    // 2023-04-25T06:00:00.000Z,
    lastUserAccess: 1682402400000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
  {
    id: '40206',
    firstName: 'Luke',
    lastName: 'Allan',
    name: 'Luke Allan',
    email: 'lallan@brazeau.rmst.edu',
    preferredDisplayName: 'Mr Luke',
    // 2023-04-21T06:00:00.000Z,
    lastUserAccess: 1682056800000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
  {
    id: '40207',
    firstName: 'Erik',
    lastName: 'Biel',
    name: 'Erik Biel',
    email: 'ebiel@rmst.edu',
    preferredDisplayName: 'Ms. Biel',
    // 2023-04-20T06:00:00.000Z,
    lastUserAccess: 1681970400000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
  {
    id: '40208',
    firstName: 'Stacey',
    lastName: 'Oshima',
    name: 'Stacey Oshima',
    email: 'soshima@brazeau.rmst.edu',
    preferredDisplayName: 'Miss Oshima',
    // 2023-04-17T06:00:00.000Z,
    lastUserAccess: 1681711200000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
  {
    id: '40209',
    firstName: 'Robert',
    lastName: 'Morales',
    name: 'Robert Morales',
    email: 'rmorales@brazeau.rmst.edu',
    preferredDisplayName: 'Mr Morales',
    // 2023-04-21T06:00:00.000Z,
    lastUserAccess: 1682056800000,
    emailStatus: 'VERIFIED',
    accountStatus: 'MEMBER',
    pro: true,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
  {
    id: '40210',
    firstName: 'Jacob',
    lastName: 'Winks',
    name: 'Jacob Winks',
    email: 'jakester@hotmail.com',
    preferredDisplayName: 'Mr W',
    // 2023-04-25T06:00:00.000Z,
    lastUserAccess: 1682402400000,
    emailStatus: 'UNVERIFIED',
    accountStatus: 'MEMBER',
    pro: false,
    linkedPurchaserName: 'Brazeau Elementary School',
    linkedPurchaserId: '12002',
  },
];
